import React from 'react';
import { Button } from '@mui/material';
import useRailsClick, { RailsOperation } from '../hooks/useRailsClick';

interface Props {
  operation: RailsOperation;
  label: string;
  onItemClick?: () => void;
  onSuccess?: (json?: any) => void;
  onError?: (error: string) => void;
  buttonProps?: React.ComponentProps<typeof Button>;
}

export default function RailsButton(props: Props) {
  const onClickProps = useRailsClick(
    props.operation,
    props.onItemClick,
    props.onSuccess,
    props.onError
  );
  return (
    <div style={{ marginLeft: 8 }}>
      <Button size="small" {...onClickProps} {...props.buttonProps}>
        {props.label}
      </Button>
    </div>
  );
}
